var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"freescout-button-image",attrs:{"src":_vm.src},on:{"mouseover":function($event){_vm.hover=true},"mouseout":function($event){_vm.hover=false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }